import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'

import { Avatar } from '@tiltify/design'
import { StyledStreamEmpty } from './styles'

const StyledStream = styled.div`
  width: 100%;
  height: 0;
  display: block;
  position: relative;
  padding-top: 56.25%;
`

const StyledStreamImage = styled.img`
  background-size: 100%;
  width: 100%;
  display: block;
  height: 100%;
  border-radius: 4px 4px 0px 0px;
  ${({ theme }) => theme.transition[0]}
  position: absolute;
  top: 0;
`

const StyledMutedAvatar = styled(Avatar)`
  opacity: 0.3;
`

const AvatarWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  justify-content: center;
  align-items: center;
`

interface StreamCardProps {
  campaign?: TiltifyCampaign | TiltifyTeamEvent
  loading?: boolean
}
export const StreamCard = ({ campaign, loading }: StreamCardProps): JSX.Element => {
  const campaignImage = campaign?.cardImage?.src
  const defaultAvatar =
    campaign?.avatar?.src ||
    (campaign && 'supporting' in campaign
      ? campaign?.team?.avatar?.src
      : campaign?.user?.avatar?.src) ||
    ''

  if (loading) {
    return (
      <StyledStream>
        <StyledStreamEmpty palette={{}}>
          <Skeleton height={150} />
        </StyledStreamEmpty>
      </StyledStream>
    )
  }

  return (
    <StyledStream>
      {campaignImage && <StyledStreamImage src={campaignImage} alt='Stream' />}
      {!campaignImage && (
        <>
          <AvatarWrapper>
            <StyledMutedAvatar
              height={80}
              width={80}
              src={defaultAvatar}
              alt={`${campaign?.name} avatar`}
            />
          </AvatarWrapper>
        </>
      )}
    </StyledStream>
  )
}
